/**
 * Input de monto con formato de miles en tiempo real.
 * Muestra comas mientras el usuario escribe (3000 → "3,000").
 * Emite número limpio en onChange.
 */
export default function MoneyInput({ value, onChange, placeholder, ...props }) {
  const formatWithCommas = (n) => {
    if (!n && n !== 0) return "";
    const num = Number(n);
    if (isNaN(num) || num === 0) return "";
    // Separar parte entera y decimal
    const parts = String(num).split(".");
    parts[0] = Number(parts[0]).toLocaleString("es-MX");
    return parts.join(".");
  };

  const handleChange = (e) => {
    const raw = e.target.value.replace(/[^0-9.]/g, "");
    // Evitar múltiples puntos decimales
    const parts = raw.split(".");
    const clean = parts.length > 2 ? parts[0] + "." + parts.slice(1).join("") : raw;
    onChange(Number(clean) || 0);
  };

  const displayValue = value ? formatWithCommas(value) : "";

  return (
    <input
      type="text"
      inputMode="decimal"
      value={displayValue}
      onChange={handleChange}
      placeholder={placeholder || "0"}
      {...props}
    />
  );
}
